import { useEffect, useRef } from 'react';
import { useRouter } from '@funtech-int/rival-react';

import { cleanPlayingParams } from '@/scenarios/legacy-player/components/feature-player/utils/clean-playing-params';
import { getRelativeUrlWithoutRegionLocale } from '@/shared/lib/locale/client';

import { playingContentIdVar } from '../../player-manager/hooks/use-playing-content-id-var';
import { useStopPlayingContent } from '../../player-manager/helpers/stop-playing-content';

export const useStopPlayingContentOnPageChange = () => {
    const router = useRouter();
    const prevUrlRef = useRef('');

    const stopPlayingContent = useStopPlayingContent();

    useEffect(() => {
        const prevPathname = router.serialize(router.location);
        prevUrlRef.current = prevPathname;

        const unsubscribe = router.listen(() => {
            const playingContentId = playingContentIdVar.get();

            const currentPathname = router.serialize(router.location);
            const prevPathname = prevUrlRef.current;

            if (
                getRelativeUrlWithoutRegionLocale(currentPathname) !==
                    getRelativeUrlWithoutRegionLocale(prevPathname) &&
                playingContentId
            ) {
                cleanPlayingParams();
                stopPlayingContent();
            }

            prevUrlRef.current = currentPathname;
        });

        return unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router, stopPlayingContent]);
};
